import { render, staticRenderFns } from "./StockNew.vue?vue&type=template&id=6af6f8dc"
import script from "./StockNew.vue?vue&type=script&lang=js"
export * from "./StockNew.vue?vue&type=script&lang=js"
import style0 from "./StockNew.vue?vue&type=style&index=0&id=6af6f8dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports